<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="javascript:void(0)">App Banner Management</a>
      <div class="collapse navbar-collapse">
          <a class="btn btn-sm btn-outline-primary ms-auto" [routerLink]="['/lo', company_uuid, 'front', 'banner', 'form']">&#43; Add Banner</a>
      </div>
    </div>
  </nav>
  <hr/>
  <div class="row">
    <app-tablev2 #table></app-tablev2>
  </div>